// extracted by mini-css-extract-plugin
module.exports = {"container":"P2ps","tabContainer":"tNXo","subNavItemActive":"Zk36","subNavItemInactive":"YcEi","unreadDot":"ENI7","svgIcon":"PbW-","svgIconSelected":"kTCu"};